// extracted by mini-css-extract-plugin
export default {"xxlBreakPoint":"1440px","extraLargeBreakPoint":"1200px","largeBreakPoint":"1000px","mobileBreakPoint":"750px","errorPanel":"Error_errorPanel__XvH0x"};